import { Component, Inject } from '@angular/core';
import { SessionService } from '../session.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../external-settings/external-settings.interface';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ResponsiveDesignService } from '../../responsive-design/responsive-design.service';

@Component({
    selector: 'app-session-confirm',
    templateUrl: './session-confirm.component.html',
    styleUrl: './session-confirm.component.less',
    standalone: false
})
export class SessionConfirmComponent {

  UIUtilityService: any = UIUtilityService;

  externalSettings: ExternalSettings;
  service: SessionService;
  remainingTime: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogConfig,
    public dialog: MatDialogRef<SessionConfirmComponent>,
    protected srvRpDesign: ResponsiveDesignService
  ) {
    this.externalSettings = data.externalSettings;
    this.service = data.service;
    this.remainingTime = data.remainingTime;

    setInterval(() => {
      this.remainingTime -= 1;

      if (this.remainingTime <= 0) {
        this.cancel(null);
      }
    }, 1000);
  }


  cancel(_event: any): void {
    this.dialog.close(false);
  }
  confirm(_event: any): void {
    this.dialog.close(true);
  }


}

export interface ConfirmDialogConfig {
  service: SessionService,
  externalSettings: ExternalSettings,
  remainingTime: number,
}
